import { Component } from "@angular/core";
import { CustomModal } from "../base-modals";

@Component({
	templateUrl: "./not-available-modal.component.html",
	standalone: false
})
export class NotAvailableModalComponent extends CustomModal {}
